import React from 'react'
import './css/style.css'
import Header from './components/Header'
import Hero from './components/Hero'
import About from './components/About'
import Facilities from './components/Facilities'
import Classes from './components/Classes'
import Team from './components/Team'
import AnimatedGallery from './components/AnimatedGallery'
import Testimonials from './components/Testimonials'
import GalleryMain from './components/GalleryMain'
import Contact from './components/Contact'
import Footer from './components/Footer'
import Infosxc from './components/Infosxc'
import Reveal from './components/Reveal'
import MapView from './components/MapView'
import ScrollToTop from './components/ScrollToTop';
import SliderViewer from './components/SliderViewer'
import FlashNews from './components/flashnews/FlashNews'

export default function Home() {
  return (
    <div>
      <Header />
      <FlashNews />
      <SliderViewer />
     {/*} <AnimatedGallery />*/}
      <Hero />
      
      <Reveal animation="slideUp" duration={800} delay={0}>
        <About />
      </Reveal>
      
      <Reveal animation="slideLeft" duration={800} delay={100}>
        <Facilities />
      </Reveal>

      {/*
      <Reveal animation="slideRight" duration={800} delay={100}>
        <Classes />
      </Reveal>
      
      <Reveal animation="zoomIn" duration={800} delay={100}>
        <Team />
      </Reveal>
      
      <Reveal animation="rotate" duration={800} delay={100}>
        <Testimonials />
      </Reveal>
       */}
      <Reveal animation="fade" duration={800} delay={100}>
        <GalleryMain />
      </Reveal>
     
      
      <Reveal animation="slideDown" duration={800} delay={100}>
        <Infosxc />
      </Reveal>
      
      <Reveal animation="slideUp" duration={800} delay={0}>
        <Contact />
      </Reveal>
      <Footer />
      <ScrollToTop />
    </div>
  )
}
